import * as types from "_graphql-types/graphql";
import { Tag } from "frontend/src/components/Tag/Tag";
import { removeFilter } from "Reducers/globalSearchV2/globalSearchV2.actions";
import { useDispatch } from "src/react-redux";

export default function YearFoundedFilterTag({
  filter,
}: {
  filter: types.IntRangeFilter;
}) {
  const dispatch = useDispatch();
  const { min, max } = filter;
  return (
    <Tag
      className="ant-tag--green ant-tag--close"
      data-cy="year-founded-filter-tag"
      onClose={() => {
        dispatch(
          removeFilter({
            type: "company",
            data: {
              type: "YEAR_FOUNDED",
              data: filter,
            },
          })
        );
      }}
      closable
    >
      {`Year Founded ${min ? `From: ${min}` : ""} - ${
        max ? `To: ${max}` : ""
      } `}
    </Tag>
  );
}
